import React from 'react';
import PropTypes from 'prop-types';
import css from './MeetingType.css';
import Icon from 'SF/MaterialIcon';
import { getWord } from 'utils/tenant';

function MeetingType(props) {

  const getTypeName = () => {
    switch ( props.type ) {
      case "APPOINTMENT":
        return "Appointment";
      case "WALK_IN":
        return getWord('dropIn', false);
      case "SELF_SERVICE":
        return "Self Service";
      case "GROUP_SESSION":
        return "Group Session";
      default:
        return props.type;
    }
  }

  const getMaterialIconName = () => {
    switch ( props.type ) {
      case "APPOINTMENT":
        return "insert_invitation";
      case "WALK_IN":
        return "directions_walk";
      case "GROUP_SESSION":
        return "group";
      default:
        return "";
    }
  };

  const getIcon = () => {
    return props.type === "SELF_SERVICE"
      ? <i className="fa fa-fw fa-child" aria-hidden="true" />
      : <Icon icon={getMaterialIconName()} />;
  }
  
  return (
    <div className={css['container']}>
      {getIcon()}
      <div>{getTypeName()}</div>
    </div>
  );
}

MeetingType.propTypes = {
  type: PropTypes.string.isRequired,
};

export default MeetingType;
